// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var accordion = "Accordion-module--accordion--3y-mH";
export var accordionBox = "Accordion-module--accordionBox--6f9rl";
export var greenAccordion = "Accordion-module--greenAccordion--2J77H";
export var titleBox = "Accordion-module--titleBox--3yOyG";
export var icon = "Accordion-module--icon--1o1MN";
export var body = "Accordion-module--body--1ZNBE";
export var accordionOpen = "Accordion-module--accordionOpen--1Hrri";